/**
 * 체험하기(전시회) 신청·설문 제출 함수 모음.
 *
 * ★ 체험하기는 무인증 정책이다. BE `/app/exhibition/**`, `/app/play/**`는
 *   security-ignore-uris로 등록돼 있으며, 이 화면에 인증 가드를 붙이면 안 된다.
 * 일반 신청은 exhibition 접두어, 어린이 신청은 play 접두어를 쓴다.
 * 옛 13문항(`/play`·`/play1`)과 개편판 논서술형(`/play3`·`/play4`)이 같은 POST 를 쓴다.
 * 개편판은 등록 시점에 POST 로 행을 만들고 단계마다 `{id}/essay` PATCH 로 덮어쓴다(본문은
 * `components/play/playSubmission.ts`). 설문 PATCH 는 옛 흐름만 부른다.
 */
import { ExhibitionGeneralRequest, ExhibitionChildRequest, EssayProgressRequest } from "@/types/exhibition";
import { APIClient } from "../api/client";

/** 체험하기(일반) 신청 정보를 등록한다. `POST /app/exhibition`. */
export const postExhibition = async (data: ExhibitionGeneralRequest) => {
    const result = await APIClient.client.post("/app/exhibition", data);
    return result.data;
};

/** 체험하기(일반) 신청 건에 설문 응답을 붙인다. `PATCH /app/exhibition/{id}/survey`. */
export const patchExhibitionSurvey = async (id: number, data: { survey1: number; survey2: string }) => {
    const result = await APIClient.client.patch(`/app/exhibition/${id}/survey`, data);
    return result.data;
};

/** 체험하기 개편판(일반) 논서술형 진행 저장. `PATCH /app/exhibition/{id}/essay`. 없는 id 면 404. */
export const patchExhibitionEssay = async (id: number, data: EssayProgressRequest) => {
    const result = await APIClient.client.patch(`/app/exhibition/${id}/essay`, data);
    return result.data;
};

/** 체험하기(어린이) 신청 정보를 등록한다. `POST /app/play`. */
export const postPlay = async (data: ExhibitionChildRequest) => {
    const result = await APIClient.client.post("/app/play", data);
    return result.data;
};

/** 체험하기(어린이) 신청 건에 설문 응답을 붙인다. `PATCH /app/play/{id}/survey`. */
export const patchPlaySurvey = async (id: number, data: { survey1: number; survey2: string }) => {
    const result = await APIClient.client.patch(`/app/play/${id}/survey`, data);
    return result.data;
};

/** 체험하기 개편판(학생) 논서술형 진행 저장. `PATCH /app/play/{id}/essay`. 없는 id 면 404. */
export const patchPlayEssay = async (id: number, data: EssayProgressRequest) => {
    const result = await APIClient.client.patch(`/app/play/${id}/essay`, data);
    return result.data;
};
